import { Action, Dispatch } from "redux";
import { notification } from "antd";

import { ApiService } from "../../../services";
import { type LoginFieldType } from "../../../models";
import { SET_LOGGED_USER, SET_LOADING } from "./types";
import {
  NavigationPath,
  ROLES,
  history,
  showErrorNotification,
} from "../../../utils";

const setLoading = (loading: boolean) => ({
  type: SET_LOADING,
  payload: loading,
});

export const loginUser =
  (user: LoginFieldType) => async (dispatch: Dispatch<Action>) => {
    ApiService.post("auth/login", user)
      .then(async (res) => {
        const { status, data } = res;
        if (status !== 200) {
          showErrorNotification("Prijava nije uspjela");
          return;
        }

        const { user, accessToken, refreshToken } = data;
        localStorage.setItem("userToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("currentUser", JSON.stringify(user));
        await setLoggedUser()(dispatch);
        notification.success({
          message: "Uspješno ste se prijavili.",
        });
        if (user.role === ROLES.INSURANCE_COMPANY)
          history.navigate(NavigationPath.INSURANCE_OFFER_REQUESTS_ROUTE);
        else history.navigate(NavigationPath.OFFER_REQUESTS_ROUTE);
      })
      .catch((err) => {
        showErrorNotification("Prijava nije uspjela", err);
      });
  };

export const setLoggedUser = () => async (dispatch: Dispatch<Action>) => {
  const userString = localStorage.getItem("currentUser");
  if (userString !== null) {
    const user = JSON.parse(userString);
    dispatch({
      type: SET_LOGGED_USER,
      payload: user,
    });
  }
};

export const logoutUser = () => async (dispatch: Dispatch<Action>) => {
  localStorage.removeItem("userToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("currentUser");
  dispatch({
    type: SET_LOGGED_USER,
    payload: null,
  });
  notification.success({
    message: "Uspješno ste se odjavili.",
  });
  history.navigate(NavigationPath.LOGIN_ROUTE);
};

export const sendResetPasswordEmail =
  (email: string | undefined) => async (dispatch: Dispatch<Action>) => {
    dispatch(setLoading(true));
    ApiService.post("auth/send-reset-password-email", { email })
      .then((res: any) => {
        const { status } = res;

        if (status !== 200) {
          showErrorNotification(
            "Slanje emaila za promjenu lozinke nije uspjelo"
          );
          return;
        }
        notification.success({
          message: `Email za promjenu lozinke je poslan na ${email}.`,
        });
      })
      .catch((err) => {
        showErrorNotification(
          "Slanje emaila za promjenu lozinke nije uspjelo",
          err
        );
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const resetPassword =
  (email: string | undefined, password: string, token: string) =>
  async (dispatch: Dispatch<Action>) => {
    ApiService.post("auth/reset-password", {
      email,
      password,
      token,
    })
      .then((res) => {
        const { status } = res;

        if (status !== 200) {
          showErrorNotification("Promjena lozinke nije uspjela");
          return;
        }
        notification.success({
          message: "Lozinka je promijenjena.",
        });
        history.navigate(NavigationPath.LOGIN_ROUTE);
      })
      .catch((err) => {
        showErrorNotification("Promjena lozinke nije uspjela", err);
      });
  };
